
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="relative w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-500 via-orange-600 to-orange-700 rounded-xl shadow-lg">
                {/* Crown on top */}
                <div className="absolute -top-2 left-1/2 transform -translate-x-1/2">
                  <i className="ri-vip-crown-fill text-xl text-yellow-400" style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }}></i>
                </div>
                {/* MB Letters */}
                <div className="text-white font-bold text-lg tracking-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
                  MB
                </div>
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-bold leading-tight" style={{ fontFamily: '"Playfair Display", serif' }}>Malik Brothers</span>
                <span className="text-xs text-orange-500 font-semibold tracking-wide">Quality & Trust</span>
              </div>
            </div>
            <p className="text-gray-400 mb-6">
              Your trusted partner for premium sanitary ware, kitchen fixtures, pipes, and hardware tools in Rawalpindi.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-orange-600 hover:bg-orange-700 rounded-full transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://wa.me/923135224547" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-green-500 hover:bg-green-600 rounded-full transition-all cursor-pointer">
                <i className="ri-whatsapp-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-orange-400 hover:bg-orange-500 rounded-full transition-all cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Products</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Services</Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Gallery</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-xl font-bold mb-6">Our Products</h3>
            <ul className="space-y-3">
              <li className="text-gray-400">Bathroom Sanitary</li>
              <li className="text-gray-400">Toilet Items</li>
              <li className="text-gray-400">Kitchen Items</li>
              <li className="text-gray-400">Pipes & Fittings</li>
              <li className="text-gray-400">Hardware Tools</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-orange-500 text-xl mt-1"></i>
                <span className="text-gray-400">Shop #3 Awan Plaza, Near Allied Bank, Qasim Market, Range Road, Rawalpindi</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-orange-500 text-xl"></i>
                <a href="tel:03135224547" className="text-gray-400 hover:text-white transition-colors cursor-pointer">0313-5224547</a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-time-line text-orange-500 text-xl"></i>
                <span className="text-gray-400">Mon - Sat: 9:00 AM - 8:00 PM</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2024 Malik Brothers. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Terms & Conditions</Link>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
